/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetRegionBaseRequest } from '../../models/get-region-base-request';
import { RegionModel } from '../../models/region-model';

export interface PostApiRegionV1Getall$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetRegionBaseRequest
}

export function postApiRegionV1Getall$Plain(http: HttpClient, rootUrl: string, params?: PostApiRegionV1Getall$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegionModel>>> {
  const rb = new RequestBuilder(rootUrl, postApiRegionV1Getall$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RegionModel>>;
    })
  );
}

postApiRegionV1Getall$Plain.PATH = '/private/v1/regions';
